import { AppConfig } from "./types";

export const APP_VERSION = "26.04.17";

const configs: Record<string, AppConfig> = {
	staging_za: {
		aws_url: "https://api.xplan-outlook-plugin.aws-wealth-staging-za.iress.online/lambda",
		redirect_url:
			"https://xplan-outlook-plugin.aws-wealth-staging-za.iress.online/callback.html",
		bucket_name: "xplan-outlook-plugin.aws-wealth-staging-za.iress.online",
		app_client_id: "0gCk1iPOQXhPsgSaHMuI",
		environment: "staging_za",
		awsRegion: "af-south-1",
		hidden_urls: {
			Internal_Test: {
				url: "https://enterprisedemo.xplan.iress.co.za",
				redirect: "https://zabetacloud.xplan.aws-wealth-staging-za.iress.online",
			},
			Sanlam_Prod: {
				url: "https://sanfin.sanlamadvice.co.za/sanfin",
				redirect: "https://sanfin.sanlamadvice.co.za/sanfin",
			},
			Sanlam_PPE: {
				url: "https://sanfin-ppe.sanlamadvice.co.za/sanfin",
				redirect: "https://sanfin-ppe.sanlamadvice.co.za/sanfin",
			},
			Sanlam_TST: {
				url: "https://sanfin-tst.sanlamadvice.co.za/sanfin-tst",
				redirect: "https://sanfin-tst.sanlamadvice.co.za/sanfin-tst",
			},
		},
		sso_enabled_sites: [],
	},
	production_za: {
		aws_url: "https://api.outlookplugin.iress.co.za/lambda",
		redirect_url: "https://outlookplugin.iress.co.za/callback.html",
		app_client_id: "TT05MsAYQG0dTNY7pUXC",
		environment: "production-za",
		awsRegion: "af-south-1",
		bucket_name: "outlookplugin.iress.co.za",
		hidden_urls: {
			Sanlam_Prod: {
				url: "https://sanfin.sanlamadvice.co.za/sanfin",
				redirect: "https://sanfin.sanlamadvice.co.za/sanfin",
			},
			Sanlam_PPE: {
				url: "https://sanfin-ppe.sanlamadvice.co.za/sanfin",
				redirect: "https://sanfin-ppe.sanlamadvice.co.za/sanfin",
			},
			Sanlam_TST: {
				url: "https://sanfin-tst.sanlamadvice.co.za/sanfin-tst",
				redirect: "https://sanfin-tst.sanlamadvice.co.za/sanfin-tst",
			},
			Sanlam_Prod_Nam: {
				url: "https://sanfinnam.sanlamadvice.co.za/sanfinnam",
				redirect: "https://sanfinnam.sanlamadvice.co.za/sanfinnam",
			},
			Sanlam_PPE_Nam: {
				url: "https://sanfinnam-ppe.sanlamadvice.co.za/sanfinnam",
				redirect: "https://sanfinnam-ppe.sanlamadvice.co.za/sanfinnam",
			},
			Sanlam_TST_Nam: {
				url: "https://sanfinnam-tst.sanlamadvice.co.za/sanfinnam",
				redirect: "https://sanfinnam-tst.sanlamadvice.co.za/sanfinnam",
			},
			Internal_Test: {
				url: "https://enterprisedemo.xplan.iress.co.za",
				redirect: "https://enterprisedemo.xplan.iress.co.za",
			},
		},
		sso_enabled_sites: [],
	},
	production_ca: {
		aws_url: "https://api.xplan-outlook-plugin.aws-wealth-production-ca.iress.online/lambda",
		redirect_url: "https://outlookplugin.iress.com.au/callback.html",
		app_client_id: "BOEurQq3tG1aAfacqqmN",
		environment: "production-ca",
		awsRegion: "ca-central-1",
		bucket_name: "xplan-outlook-plugin.aws-wealth-production-ca.iress.online",
		hidden_urls: {},
		sso_enabled_sites: [],
	},
	production_uk: {
		aws_url: "https://api.outlookplugin.iress.co.uk/lambda",
		redirect_url: "https://outlookplugin.iress.co.uk/callback.html",
		app_client_id: "XCpCGiKQkDLgDGD8WRsM",
		environment: "production_uk",
		awsRegion: "eu-west-2",
		bucket_name: "outlookplugin.iress.co.uk",
		hidden_urls: {
			Internal_Test: {
				url: "https://enterprisedemo.xplan.iress.co.za",
				redirect: "https://enterprisedemo.xplan.iress.co.za",
			},
		},
		sso_enabled_sites: [],
	},
	production_au: {
		aws_url: "https://api.outlookplugin.iress.com.au/lambda",
		redirect_url: "https://outlookplugin.iress.com.au/callback.html",
		app_client_id: "QBdl2J3t0piaLLpCYOms",
		environment: "production_au",
		awsRegion: "ap-southeast-2",
		bucket_name: "outlookplugin.iress.com.au",
		hidden_urls: {
			Internal_Test: {
				url: "https://enterprisedemo.xplan.iress.co.za",
				redirect: "https://enterprisedemo.xplan.iress.co.za",
			},
		},
		sso_enabled_sites: [
			"https://modeloffice.xplan.iress.com.au",
			"https://modelofficetest.xplan.iress.com.au",
			"https://modelofficedemo.xplan.iress.com.au",
			"https://accountexecsfour.xplan.iress.com.au",
			"https://managed.xplan.iress.com.au",
			"https://iressdirect.xplan.iress.com.au",
			"https://trainingdemo.xplan.iress.com.au",
			"https://plannercentral.xplan.iress.com.au",
			"https://plannercentraltest.xplan.iress.com.au",
		],
	},
	// Global AppSource deployment - region determined by Xplan URL at runtime
	production_global: {
		aws_url: "", // Set dynamically based on Xplan URL
		redirect_url: "https://store.outlookplugin.iress.com.au/callback.html",
		app_client_id: "", // Set dynamically based on Xplan URL
		environment: "production_global",
		awsRegion: "ap-southeast-2",
		bucket_name: "store.outlookplugin.iress.com.au",
		hidden_urls: {}, // No hidden URLs for global - users enter their own Xplan URL
		sso_enabled_sites: [],
	},
};

/**
 * Determines environment from hosting domain.
 * For global AppSource, returns "production_global" which requires
 * runtime resolution of backend based on Xplan URL.
 */
function getEnvironment(): string {
	const hostname = new URL(document.URL).hostname;
	const environment = Object.keys(configs).find(
		(key) => configs[key].bucket_name === hostname
	);
	if (environment) return environment;
	
	// Default to staging for local development
	return "staging_za";
}

/**
 * Maps an Xplan URL to its regional backend configuration.
 * Used by global deployment to route to correct regional API.
 */
function getRegionFromXplanUrl(xplanUrl: string): string {
	if (!xplanUrl) return "production_au"; // Default to AU
	
	const url = new URL(xplanUrl).hostname.toLowerCase();
	
	// South Africa patterns
	if (url.includes(".co.za") || url.includes("staging-za")) {
		return url.includes("staging") ? "staging_za" : "production_za";
	}
	
	// UK patterns
	if (url.includes(".co.uk") || url.includes(".uk.")) {
		return "production_uk";
	}
	
	// Canada patterns
	if (url.includes(".ca") || url.includes("canada") || url.includes("production-ca")) {
		return "production_ca";
	}
	
	// Default to Australia
	return "production_au";
}

export function getAppConfig(): AppConfig {
	const environment = getEnvironment();
	return configs[environment];
}

/**
 * For global deployment, returns the appropriate regional config
 * based on the Xplan URL the user is connecting to.
 */
export function getRegionalConfig(xplanUrl: string): AppConfig {
	const region = getRegionFromXplanUrl(xplanUrl);
	return configs[region];
}

export function getOAuthConfig(clientId: string): AppConfig {
	const environment = Object.keys(configs).find(
		(key) => configs[key].app_client_id !== "" && configs[key].app_client_id === clientId
	);
	if (!environment) throw new Error("Unrecognized Xplan OAuth client ID. Please restart SSO login.");
	return configs[environment];
}

/**
 * Shorthand for getAppConfig() - used throughout the app
 */
export function appConfig(): AppConfig {
	return getAppConfig();
}
